import React from 'react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './select';
import { SUMMARY_TYPE_OPTIONS } from '../../constants/summarizer';
import { cn } from '../../lib/utils';

export interface SummaryTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
  placeholder?: string;
  options?: Array<{ value: string; label: string }>;
  label?: string;
  showLabel?: boolean;
}

const SummaryTypeSelector: React.FC<SummaryTypeSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  className,
  triggerClassName,
  contentClassName,
  placeholder = 'Summary Type',
  options = SUMMARY_TYPE_OPTIONS,
  label = 'Summary Type',
  showLabel = false,
}) => {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {showLabel && (
        <label className="text-xs font-medium text-gray-700 dark:text-gray-300">{label}</label>
      )}
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          className={cn(
            'max-w-[160px] bg-white text-black hover:bg-white hover:text-black',
            triggerClassName
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className={contentClassName}>
          <SelectGroup>
            {options.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SummaryTypeSelector;
